import { setFocusOnField } from '@/core/core_components/form/form'
import { bindResetButtonModal } from '@/core/input_controls/button/button'
import { countriesListHtml, emailValidation, getLocalizedMessage, showMessageAlert } from '@/core/shared'
import { getDataFromBoolean, getDataFromTextInput } from '@/core/item_assistance/receiveDataFromComponents'
import { initDataInBoolean, initDataInTextInput } from '@/core/item_assistance/initializeComponentData'

export function IndividualPersonManager(vm) {
	'use strict';

	this.action = undefined;
	this.individualPersonId = undefined;
	this.individualPersonIds = undefined;
	this.companyId = undefined;
	this.newUser = undefined;
	this.groupId = undefined;
	this.userId = undefined;
	this.activeAttribute = undefined;
	this.fields = undefined;
	this.prefix = undefined;
	this.postSaveAction = undefined;
	this.postRemoveAction = undefined;
	this.generateApiKeyButton = undefined;
	this.countries = vm.$store.getters.getCountries

	this.setProperties = function(properties) {
		this.action = properties.action || 'create';
		this.individualPersonId = properties.individualPersonId || undefined;
		this.individualPersonIds = properties.individualPersonIds || undefined;
		this.companyId = properties.companyId;
		this.newUser = properties.newUser;
		this.groupId = properties.groupId;
		this.userId = properties.userId;
		this.activeAttribute = properties.activeAttribute || undefined;
		this.fields = properties.fields || ["login", "passwordHash", "firstName", "lastName", "country", "description", "admin", "temporaryPassword", "decimalSeparator", "digitGroupingSeparator", "digitGroupingPattern", "dateFormat", "apiKey", "apiCompanyId"];
		this.prefix = properties.prefix || 'individual-person_';
		this.postSaveAction = properties.postSaveAction;
		this.postRemoveAction = properties.postRemoveAction;
		this.generateApiKeyButton = properties.generateApiKeyButton || '#' + this.prefix + 'generate-api-key';
	};

	this.initPage = function(person) {
		var manager = this;
		this.resetFields();

		if (this.action == 'edit') {
			manager.setIndividualPersonInformation(person);
			setFocusOnField(manager.activeAttribute);
			$("#api-key-box").css("display", "block");
		} else {
			$("#api-key-box").css("display", "none");
		}

		$(this.generateApiKeyButton).unbind('click');
		$(this.generateApiKeyButton).click(function() { manager.updateApiKey(person); });

		bindResetButtonModal();
	};

	this.saveIndividualPerson = function(action, individualPersonInformation) {

		var url = (action == 'edit') ? 'person/update' : 'person/create';

		var individualPerson = this;

		$.ajax({
			url: window.urlContext + url,
			type: 'POST',
			data: JSON.stringify(individualPersonInformation),
			contentType: 'application/json; charset=UTF-8',

			success: function () {
				if (individualPerson.postSaveAction)
					individualPerson.postSaveAction();
				showMessageAlert(getLocalizedMessage("changes.saved"), 'success');
			},
			error: function () {
				showMessageAlert(getLocalizedMessage("error.saving"), 'danger');
			}
		});
	};

	this.initRemoveIndividualPerson = function (id) {
		var manager = this;
		Swal.fire({
			title: getLocalizedMessage('remove.person.confirmation'),
			showCancelButton: true,
			cancelButtonText: getLocalizedMessage('cancel'),
			buttonsStyling: false,
			allowEnterKey: true,
			showClass: {
				popup: ''
			},
			hideClass: {
				popup: ''
			},
			customClass: {
				confirmButton: 'uk-button uk-button-primary uk-button-small uk-margin-small-right',
				cancelButton: 'uk-button uk-button-default uk-button-small',
			},
			onRender: function () {
				manager.setProperties({
					action: 'remove',
					individualPersonId: {id: id},
					postRemoveAction: function () {
						table.initTable();
						table.selectedItemsManager.deleteRowMarkById(id);
					}
				});
			}
		}).then(function (result) {
			if (result.value) {
				manager.removeIndividualPerson();
			}
		});
	};

	this.initRemoveIndividualPersons = function (ids) {
		var manager = this;
		Swal.fire({
			title: getLocalizedMessage('remove.persons.confirmation'),
			showCancelButton: true,
			cancelButtonText: getLocalizedMessage('cancel'),
			buttonsStyling: false,
			allowEnterKey: true,
			showClass: {
				popup: ''
			},
			hideClass: {
				popup: ''
			},
			customClass: {
				confirmButton: 'uk-button uk-button-primary uk-button-small uk-margin-small-right',
				cancelButton: 'uk-button uk-button-default uk-button-small',
			},
			onRender: function () {
				manager.setProperties({
					action: 'remove',
					individualPersonIds: ids,
					postRemoveAction: function() {
						table.initTable();
						table.selectedItemsManager.clearSelections(table);
					}
				});
			}
		}).then(function (result) {
			if (result.value) {
				manager.removeIndividualPersons();
			}
		});
	};

	this.removeIndividualPerson = function() {
		var manager = this;
		$.ajax({
			type: 'POST',
			url: window.urlContext + 'persons/delete',
			data: {
				ids: JSON.stringify([this.individualPersonId.id]),
			},
			success: function () {
				if (manager.postRemoveAction)
					manager.postRemoveAction();
				showMessageAlert(getLocalizedMessage("removed.individual.person"), 'success');
			},
			error: function () {
				showMessageAlert(getLocalizedMessage("error.remove.individual.person"), 'danger');
			}
		});
	};

	this.removeIndividualPersons = function() {
		var manager = this;
		$.ajax({
			type: 'POST',
			url: window.urlContext + 'persons/delete',
			data: {ids: JSON.stringify(manager.individualPersonIds)},
			success: function () {
				if (manager.postRemoveAction)
					manager.postRemoveAction();
				showMessageAlert(getLocalizedMessage("removed.individual.persons"), 'success');
			},
			error: function () {
				showMessageAlert(getLocalizedMessage("error.remove.individual.persons"), 'danger');
			}
		});
	};

	this.updateApiKey = function(person) {
		var manager = this;
		$.ajax({
			url: window.urlContext + 'person/api-key/generate?id=' + manager.individualPersonId,
			type: 'POST',

			success: function (apiKey) {
				initDataInTextInput(manager.prefix + 'apiKey', apiKey);
				person.apiKey = apiKey;
			},
			error: function () {
				showMessageAlert(getLocalizedMessage("error.api-key.generate"), 'error', 'danger')
			}
		});
	};

	this.showPasswordError = function(message) {
		Swal.fire({
			title: message,
			icon: 'error',
			allowOutsideClick: true
		});
	};

	this.setIndividualPersonInformation = function(data) {
		var individualPerson = this;
		_.each(data, function(value, key) {
			initDataInTextInput(individualPerson.prefix + key, value);
		});
		initDataInBoolean(individualPerson.prefix + 'admin', data.admin);
		initDataInBoolean(individualPerson.prefix + 'temporaryPassword', data.temporaryPassword);
	};

	this.resetFields = function() {
		var individualPerson = this;
		_.each(this.fields, function(field) {
			if (field !== 'country')
				initDataInTextInput(individualPerson.prefix + field, '');
		});
		initDataInTextInput('confirmation-password', '');
		initDataInTextInput(individualPerson.prefix + "decimalSeparator", '.');
		initDataInTextInput(individualPerson.prefix + "digitGroupingSeparator", ' ');
		initDataInTextInput(individualPerson.prefix + "digitGroupingPattern", '0');
		initDataInTextInput(individualPerson.prefix + "dateFormat", 'yyyy-MM-dd');
		initDataInBoolean(individualPerson.prefix + 'admin', false);
		initDataInBoolean(individualPerson.prefix + 'temporaryPassword', false);
	};

	this.getIndividualPersonInformation = function() {
		var individualPerson = this;
		var individualPersonInformation = {};

		_.each(this.fields, function(field) {
			individualPersonInformation[field] = getDataFromTextInput(individualPerson.prefix + field);
		});
		if (this.action === 'edit') {
			individualPersonInformation['id'] = this.individualPersonId;
		} else {
			delete individualPersonInformation['apiKey'];
		}
		individualPersonInformation['temporaryPassword'] = getDataFromBoolean(individualPerson.prefix + 'temporaryPassword');

		return individualPersonInformation;
	};
}
